<template lang="pug">
  b-modal#taichiNotificationModal(
    :ref="'taichi-notification'"
    title="系統通知"
    :ok-title="isSummaryMode ? '關閉' : '進入教室'"
    cancel-title="關閉"
    centered
    :ok-disabled="!isSummaryMode && notificationAction !== 'access_classroom'"
    :ok-only="isSummaryMode"
    @ok="isSummaryMode ? closeModal() : handleAction()"
    @cancel="closeModal"
    @hidden="onModalHidden"
    header-bg-variant="primary"
  )
    template(v-if="isSummaryMode")
      h4.text-center 您有 {{ messageQueue.length + 1 }} 則未讀通知
      p.text-center 點擊關閉後將逐條顯示
    template(v-else)
      h4.text-center {{ notificationTitle }}
      p.text-center {{ notificationContent }}
      p.text-center.text-muted.small(v-if="messageQueue.length > 0") 還有 {{ messageQueue.length }} 則未讀通知
</template>

<script>
import storage from '@/utils/localStorage';
import { connectTaichiSocket, onTaichiMessage, disconnectTaichiSocket, markMessageAsRead } from '@/utils/taichiSocket';

const SUMMARY_THRESHOLD = 3;

export default {
  name: 'TaichiNotification',

  data() {
    return {
      notificationTitle: '',
      notificationContent: '',
      notificationAction: '',
      notificationData: null,
      messageQueue: [],
      isSummaryMode: false,
    };
  },

  created() {
    const token = storage.token;
    if (token && token !== '' && token !== 'null') {
      connectTaichiSocket(token);
      onTaichiMessage(this.enqueueMessage);

      if ('Notification' in window && Notification.permission === 'default') {
        Notification.requestPermission();
      }
    }
  },

  beforeDestroy() {
    disconnectTaichiSocket();
  },

  methods: {
    showMessage(msg) {
      this.notificationTitle = msg.title || '系統通知';
      this.notificationContent = msg.content || '';
      this.notificationAction = msg.metadata?.action || '';
      this.notificationData = msg;
      this.isSummaryMode = false;
      this.$bvModal.show('taichiNotificationModal');

      // 彈窗顯示時標記為已讀
      if (msg.id) {
        var token = storage.token;
        if (token) {
          markMessageAsRead(token, msg.id);
        }
      }
    },

    enqueueMessage(msg) {
      // 檢查 modal 是否正在顯示
      const modalVisible = this.$refs['taichi-notification']?.isVisible;
      if (modalVisible) {
        this.messageQueue.push(msg);
      } else if (this.messageQueue.length >= SUMMARY_THRESHOLD - 1) {
        this.messageQueue.push(msg);
        this.isSummaryMode = true;
        this.$bvModal.show('taichiNotificationModal');
      } else if (this.messageQueue.length > 0) {
        this.messageQueue.push(msg);
        this.showNextMessage();
      } else {
        this.showMessage(msg);
      }
    },

    showNextMessage() {
      if (this.messageQueue.length === 0) {
        return;
      }
      if (this.messageQueue.length >= SUMMARY_THRESHOLD) {
        this.isSummaryMode = true;
        this.$bvModal.show('taichiNotificationModal');
        return;
      }
      const next = this.messageQueue.shift();
      this.showMessage(next);
    },

    onModalHidden() {
      if (this.isSummaryMode) {
        this.isSummaryMode = false;
        this.$nextTick(() => this.showNextMessage());
      } else {
        this.$nextTick(() => this.showNextMessage());
      }
    },

    handleAction() {
      if (this.notificationAction === 'access_classroom') {
        if (this.notificationData?.metadata?.join_url) {
          window.open(this.notificationData.metadata.join_url);
        }
      }
      this.closeModal();
    },

    closeModal() {
      this.$bvModal.hide('taichiNotificationModal');
    },
  },
};
</script>
